/* =========================================================
   DEFAULT SETTINGS
========================================================= */
export const defaultSettings = {
    temperature: 1.0, topP: 1.0, topK: 0,
    frequencyPenalty: 0.0, presencePenalty: 0.0,
    repetitionPenalty: 1.0, minP: 0.0, topA: 0.0,
    seed: null, maxTokens: null, logprobs: false, topLogprobs: null,
    streaming: true,
    reasoning: { effort: null, maxTokens: null, exclude: false },
};